import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import PpeRequirementsSection from 'components/settings/projectConfiguration/PpeRequirementsSection';

export default function PpeRequirementsSectionWrapper({
  contextProps,
  wrappedProps,
}) {
  return (
    <AppWrapper {...contextProps}>
      <PpeRequirementsSection {...wrappedProps} />
    </AppWrapper>
  );
}
